import { type SyncApp } from '../../server/sync';
import { type Checkpoint, syncErrorSchema } from '../../shared/sync/schemas';
import {
  workspacesPullOutput,
  workspacesPushOutput,
  type WorkspacesPushRow,
} from '../../shared/sync/workspaces';
import { hc } from 'hono/client';

const client = hc<SyncApp>('/api/sync', {
  fetch: (input: RequestInfo | URL, init?: RequestInit) =>
    fetch(input, { ...init, credentials: 'include' }),
});

type FetchLike = { json: () => Promise<unknown>; ok: boolean; status: number };

const throwSyncError = async (res: FetchLike): Promise<never> => {
  let body: unknown;
  try {
    body = await res.json();
  } catch {
    throw new Error(`sync ${res.status}`);
  }

  const parsed = syncErrorSchema.safeParse(body);
  const code = parsed.success ? parsed.data.code : 'BAD_REQUEST';
  const message = parsed.success ? parsed.data.message : `sync ${res.status}`;
  throw new Error(`[${code}] ${message}`);
};

export const pullWorkspaces = async (input: {
  batchSize: number;
  checkpoint: Checkpoint | null;
}) => {
  const res = await client.v1.workspaces.pull.$post({
    json: {
      batchSize: input.batchSize,
      checkpoint: input.checkpoint,
    },
  });
  if (!res.ok) {
    await throwSyncError(res);
  }

  return workspacesPullOutput.parse(await res.json());
};

export const pushWorkspaces = async (rows: WorkspacesPushRow[]) => {
  const res = await client.v1.workspaces.push.$post({ json: { rows } });
  if (!res.ok) {
    await throwSyncError(res);
  }

  return workspacesPushOutput.parse(await res.json());
};
